export const defaultAdkFolder = '.adk'
//
